<span class="material-icons" [ngClass]="{'text-danger': !buildVersion.version}" [matTooltip]="buildVersion.version ? 'v' + buildVersion.version : 'N/A'">build_circle</span>
